import { 
  RefreshCcw, Search, 
  Loader2, 
  Send,
  FileSpreadsheet,
} from 'lucide-react';
import { React, useState, useEffect } from 'react';
import axios from "axios";
import Select from "react-select";
import SelectDate from "../cors/SelectDate";
import { toast } from "sonner";
import { useAuth } from "../context/AuthProvider";
import { BASE_URL } from "../apiConfig";
import Loading from '../cors/Loading';
import ImportOrdersGoogleSheets from './ImportOrdersGoogleSheets';
import irsaliyat from '../images/irsaliyat.png'
import turboliv from '../images/turboliv.png'
import ozon from '../images/ozon.png'
import tawsilex from '../images/tawsilex.png'


export default function FilterOrders({
  role,
  token,
  status,
  loading,
  setLoading,
  searchTerm,
  setSearchTerm,
  fetchOrders,
  setDateRange,
  selectedOrders,
  handleSendOrders,
  sendingOrders,
  selectedSeller,
  setSelectedSeller,
  selectedCompany,
  setSelectedCompany,
  setShowLivreurModal,
  pagination,
  selectedLivreur,
  setSelectedLivreur
}) {
  const [options, setOptions] = useState([{ value: '', label: 'Tous les vendeurs' }]);
  const [livreurOptions, setLivreurOptions] = useState([{ value: '', label: 'Touts les livreurs' }]);
  const [loadingSellers, setLoadingSellers] = useState(false);
  const [loadingLivreurs, setLoadingLivreurs] = useState(false);
  const [showCompanyModal, setShowCompanyModal] = useState(false);
  const [searchDebounce, setSearchDebounce] = useState(null);
  const [currentDateRange, setCurrentDateRange] = useState(null);
  const [companies, setCompanies] = useState([]);
  const [showImportModal, setShowImportModal] = useState(false);
  const { roles } = useAuth();


  const getCompanyLogo = (name) => {
    switch (name.toLowerCase()) {
      case 'irsaliyat':
        return irsaliyat
      case 'turboliv':
        return turboliv
      case 'ozon':
        return ozon
      case 'tawsilex':
        return tawsilex
      default:
        return null
    }
  }
  

  useEffect(() => {
    if (showCompanyModal === true) {
      const fetchCompanies = async () => {
        try {
          const res = await axios.get(
            `${BASE_URL}/api/delivery-companies`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
  
          // keep only active companies
          const activeCompanies = res.data.data
            .filter(company => company.status === "true")
            .map(company => ({
              id: company.id,
              name: company.name,
              logo: getCompanyLogo(company.name),
            }));
  
          setCompanies(activeCompanies);
        } catch (err) {
          toast.error("Erreur lors du chargement des vendeurs");
        }
      };
  
      fetchCompanies();
    }
  }, [showCompanyModal]);
  

  const fetchSellers = async () => {
    try {
      setLoadingSellers(true);
      const res = await axios.get(`${BASE_URL}/api/search-saller`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      
      const sellers = res.data.data || [];
      const sellerOptions = [
        { value: '', label: 'Tous les vendeurs' },
        ...sellers.map((s) => ({
          value: s.id,
          label: `${s.name ?? "Unknown"} (${s.name_store ?? "No Store"}) - ${s.status}`,
        }))
      ];

      setOptions(sellerOptions);
      
      if (!selectedSeller) {
        setSelectedSeller(sellerOptions[0]);
      }
    } catch (err) {
      console.error("Error fetching sellers:", err);
      toast.error("Erreur lors du chargement des vendeurs");
      setOptions([{ value: '', label: 'Tous les vendeurs' }]);
    } finally {
      setLoadingSellers(false);
    }
  };

  const fetchLivreurs = async () => {
    try {
      setLoadingLivreurs(true);
      const res = await axios.get(`${BASE_URL}/api/livreurs`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      
      const livreursData = res.data || [];
      const optionsMapped = [
        { value: '', label: 'Touts les livreurs' },
        ...livreursData.map((l) => ({
          value: l.id,
          label: `${l.name ?? "Unknown"} (${l.phone ?? ""})`,
        }))
      ];

      setLivreurOptions(optionsMapped);
      
      if (!selectedLivreur) {
        setSelectedLivreur(optionsMapped[0]);
      }
    } catch (err) {
      console.error("Error fetching livreurs:", err);
      toast.error("Erreur lors du chargement des livreurs");
      setLivreurOptions([{ value: '', label: 'Touts les livreurs' }]);
    } finally {
      setLoadingLivreurs(false);
    }
  };

  const handleDateRangeChange = (range) => {
    console.log('Date range from SelectDate:', range);
    
    setCurrentDateRange(range);
    setDateRange(range);
    setLoading(true);
    
    fetchOrders(1, searchTerm, range, selectedSeller?.value, selectedLivreur?.value);
  };

  const handleSellerChange = (selectedOption) => {
    setSelectedSeller(selectedOption);
    setLoading(true);
    const sellerId = selectedOption?.value || null;
    
    fetchOrders(1, searchTerm, currentDateRange, sellerId, selectedLivreur?.value);
  };

  const handleLivreurChange = (selectedOption) => {
    setSelectedLivreur(selectedOption);
    setLoading(true);
    const livreurId = selectedOption?.value || null;
    
    fetchOrders(1, searchTerm, currentDateRange, selectedSeller?.value, livreurId);
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    
    if (searchDebounce) {
      clearTimeout(searchDebounce);
    }
    
    const timeout = setTimeout(() => {
      setLoading(true);
      fetchOrders(1, value, currentDateRange, selectedSeller?.value, selectedLivreur?.value);
    }, 500);
    
    setSearchDebounce(timeout);
  };

  const handleRefresh = () => {
    setLoading(true);
    fetchOrders(pagination?.currentPage || 1, searchTerm, currentDateRange, selectedSeller?.value, selectedLivreur?.value);
  };

  const handleSendClick = () => {
    if (selectedOrders.length === 0) {
      toast.warning('Aucune commande sélectionnée');
      return;
    }
    setShowCompanyModal(true);
  };

  const handleConfirmSend = () => {
    if (!selectedCompany) {
      toast.warning('Veuillez sélectionner une entreprise');
      return;
    }
    setShowCompanyModal(false);
    handleSendOrders();
  };

  return (
    <div className="max-w-7xl mt-5">
      <div className="flex justify-end items-center gap-2 max-sm:gap-3 max-md:grid max-sm:w-full">
        {/* Search Input */}
        <div className="relative">
          <input
            type="text"
            value={searchTerm}
            onChange={handleSearchChange}
            placeholder="Rechercher commandes..."
            className="pl-10 max-lg:w-full pr-4 py-2 shadow-sm text-xs rounded-full bg-white focus:ring-2 focus:ring-[var(--color-primary-300)] focus:border-transparent outline-none transition-all duration-200 w-64"
          />
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
        </div>

        <div className="flex gap-2 max-sm:justify-end">
          {status === "nouveau" && (role === 1 || role === 2 || role === 0) && (
            <button
              onClick={() => setShowImportModal(true)}
              disabled={loading || sendingOrders}
              className="flex text-nowrap max-lg:max-w-max items-center gap-2 rounded-full text-white bg-green-600 shadow-sm py-2 px-4 cursor-pointer text-xs hover:bg-green-700 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <FileSpreadsheet className="w-4 h-4" />
              <span>Importer Google Sheets</span>
            </button>
          )}
          {    ((status === "confirme" && role === 1)
            || (status === "confirme" && role === 2 && roles.send_delivery === 1)) &&
          (
            <>
              <button
                onClick={handleSendClick}
                disabled={selectedOrders.length === 0 || sendingOrders}
                className="flex text-nowrap max-lg:max-w-max items-center gap-2 rounded-full text-white bg-[var(--color-primary-500)] shadow-sm py-2 px-4 cursor-pointer text-xs hover:bg-[var(--color-primary-400)] transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {sendingOrders ? (
                  <>
                    <Loader2 className="w-4 h-4 animate-spin" />
                    <span>Envoi...</span>
                  </>
                ) : (
                  <>
                    <Send className="w-4 h-4" />
                    <span>Envoyer ({selectedOrders.length})</span>
                  </>
                )}
              </button>
              
              <button
                onClick={() => setShowLivreurModal(true)}
                disabled={selectedOrders.length === 0}
                className="flex text-nowrap max-lg:max-w-max items-center gap-2 rounded-full text-white bg-orange-500 shadow-sm py-2 px-4 cursor-pointer text-xs hover:bg-orange-600 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <Send className="w-4 h-4" />
                <span>Envoyer au Livreur ({selectedOrders.length})</span>
              </button>
            </>
          )}

          {/* Refresh Button */}
          <button 
            className="flex max-lg:max-w-max items-center gap-1 border border-gray-200 rounded-full bg-white shadow-xs py-2 px-4 cursor-pointer text-xs hover:bg-gray-50 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
            onClick={handleRefresh}
            disabled={loading || sendingOrders} 
          >
            <RefreshCcw 
              className={`w-4 h-4 text-[var(--color-primary-500)] transition-transform duration-500 ${
                loading ? 'animate-spin' : ''
              }`} 
            />
            <span>{loading ? 'Actualisation...' : 'Actualiser'}</span>
          </button>
        </div>
      </div>

      {/* Seller Select and Date Range */}
        <div 
        onClick={()=>{ 
          if (role === 1 || role === 2) {
            fetchSellers();
          }
         }}
        className="flex max-sm:grid items-center justify-end gap-3 max-sm:w-full max-sm:justify-normal max-lg:mt-3 mt-3">
        {(role === 1 || role === 2) && (
              <Select
              
            instanceId="seller-select"
            options={options}
            value={selectedSeller}
            isLoading={loadingSellers}
            placeholder="Rechercher un vendeur..."
            className="text-xs rounded-2xl shadow-sm outline-none border-0 max-sm:w-full"
            onChange={handleSellerChange}
            isClearable={false}
            styles={{
              control: (provided, state) => ({
                ...provided,
                cursor: 'pointer',
                border: 'none',
                borderRadius: '20px',
                minWidth: '16rem',
                boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1)',
                outline: 'none',
                '&:hover': {
                  border: 'none',
                  boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1)'
                },
                '&:focus': {
                  border: 'none',
                  boxShadow: '0 0 0 2px rgba(10, 179, 156, 0.2)'
                }
              }),
              dropdownIndicator: (provided) => ({
                ...provided,
                padding: 4,
              }),
              clearIndicator: (provided) => ({
                ...provided,
                padding: 4,
              }),
              valueContainer: (provided) => ({
                ...provided,
                padding: '0px 13px'
              }),
            }}
          />
        )}
        {(role === 1 || role === 2) && (
              <Select
              onMenuOpen={() => fetchLivreurs()}
            instanceId="livreur-select"
            options={livreurOptions}
            value={selectedLivreur}
            isLoading={loadingLivreurs}
            placeholder="Rechercher un livreur..."
            className="text-xs rounded-2xl shadow-sm outline-none border-0 max-sm:w-full"
            onChange={handleLivreurChange}
            isClearable={false}
            styles={{
              control: (provided, state) => ({
                ...provided,
                cursor: 'pointer',
                border: 'none',
                borderRadius: '20px',
                minWidth: '16rem',
                boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1)',
                outline: 'none',
                '&:hover': {
                  border: 'none',
                  boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1)'
                },
                '&:focus': {
                  border: 'none',
                  boxShadow: '0 0 0 2px rgba(10, 179, 156, 0.2)'
                }
              }),
              dropdownIndicator: (provided) => ({
                ...provided,
                padding: 4,
              }),
              clearIndicator: (provided) => ({
                ...provided,
                padding: 4,
              }),
              valueContainer: (provided) => ({
                ...provided,
                padding: '0px 13px'
              }),
            }}
          />
        )}
          <SelectDate type={true} onDateRangeChange={handleDateRangeChange} />
        </div>

      {showCompanyModal && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[9999]">
          <div className="bg-white rounded-lg p-6 w-96 max-w-[90vw]">
            <h3 className="text-sm font-semibold mb-4">Sélectionner une entreprise</h3>
            
            <div className="space-y-3 mb-6">
              {
              companies.length > 0 ?
              
              companies.map(company => (
                <label
                  key={company.id}
                  className={`flex items-center space-x-3 p-3 border rounded-xl cursor-pointer transition-all ${
                    selectedCompany == company.id 
                      ? 'border-[var(--color-primary-500)] bg-[var(--color-primary-50)] border-2' 
                      : 'border-gray-300 hover:border-[var(--color-primary-200)]'
                  }`}
                >
                  <input
                    type="radio"
                    name="company"
                    value={company.id}
                    checked={selectedCompany === company.id}
                    onChange={(e) => setSelectedCompany(e.target.value)}
                    className="hidden"
                  />
                  
                  <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${
                    selectedCompany == company.id ? 'border-[var(--color-primary-500)]' : 'border-gray-400'
                  }`}>
                    {selectedCompany == company.id && (
                      <div className="w-2.5 h-2.5 bg-[var(--color-primary-500)] rounded-full"></div>
                    )}
                  </div>
                  
                  <img 
                    src={company.logo}
                    width={30}
                    height={30}
                    alt={company.name}
                  />
                  
                  <span className="text-gray-800 text-xs font-medium">{company.name}</span>
                </label>
              ))
              :
              <div className="w-full flex justify-center pt-3">
                <Loading />
              </div>
            }
            </div>

            <div className="flex justify-end gap-3">
              <button
                onClick={() => {
                  setShowCompanyModal(false);
                  setSelectedCompany();
                }}
                className="px-4 py-2 text-xs border border-gray-200 rounded-full cursor-pointer text-gray-600 hover:text-gray-800 hover:bg-gray-50 transition-colors"
              >
                Annuler
              </button>
              <button
                onClick={handleConfirmSend}
                disabled={!selectedCompany || sendingOrders}
                className="flex text-xs cursor-pointer items-center gap-2 rounded-full text-white bg-[var(--color-primary-500)] shadow-sm py-2 px-4 hover:bg-[var(--color-primary-400)] transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {sendingOrders && <Loader2 className="w-4 h-4 animate-spin" />}
                Confirmer l'envoi
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Import Google Sheets Modal */}
      {showImportModal && (
        <ImportOrdersGoogleSheets
          isOpen={showImportModal}
          onClose={() => setShowImportModal(false)}
          fetchOrders={fetchOrders}
        />
      )}
    </div>
  );
}

